const Module1Menu = [
  {
    heading: "menu",
    route: "/components",
    pages: [
      {
        heading: "List View",
        route: "/components/list-view",
        fontIcon: "bi-dashboard",
        svgIcon: "media/icons/duotune/general/gen025.svg",
      },
      {
        heading: "Buttons",
        route: "/components/buttons",
        fontIcon: "bi-dashboard",
        svgIcon: "/media/icons/duotune/general/gen026.svg",
      },
      {
        heading: "Tree view",
        route: "tree-view",
        fontIcon: "bi-dashboard",
        svgIcon: "/media/icons/duotune/general/gen027.svg",
      },
      {
        heading: "Image crop",
        route: "image-crop",
        fontIcon: "bi-dashboard",
        svgIcon: "/media/icons/duotune/general/gen027.svg",
      },
      {
        heading: "File upload",
        route: "file-upload",
        fontIcon: "bi-dashboard",
        svgIcon: "/media/icons/duotune/general/gen027.svg",
      },
      {
        heading: "Drag & drop",
        route: "drag",
        fontIcon: "bi-dashboard",
        svgIcon: "/media/icons/duotune/general/gen027.svg",
      },
      {
        heading: "Forms",
        route: "forms",
        fontIcon: "bi-dashboard",
        svgIcon: "/media/icons/duotune/general/gen027.svg",
      },
    ],
  },
];

export default Module1Menu;
